module.exports = __webpack_public_path__ + "static/media/omg.a7e932a3.mp3";